import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList, getClientid } from "redux/selectors";
import { CALL_API } from "common/API";

const usePendingCounts = () => {
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const ClientId = useSelector(getClientid);
  const currentUser = userList.find((user) => user.userid === userInfo?.userid);
  const country = currentUser?.managingoffice?.[0];

  const [data, setData] = useState({
      pendingCounts: {
        timesheet: 0,
        billing: 0,
        pfa: 0,
        leave: 0,
        appraisal: 0,
      },
      lastUpdated: {
        timesheet: null,
        billing: null,
        pfa: null,
        leave: null,
        appraisal: null,
      },
    }
  );
  const [isLoading, setIsLoading] = useState(true);

  const fetchNotificationCounts = useCallback(async () => {
    if (!userInfo?.userid || !ClientId) return;

    setIsLoading(true);
    try {
      const response = await CALL_API(
        "insyts-user-dashboard/notification",
        "post",
        {
          weeks: [],
          statusArray: ["pending"],
          employeeId: currentUser?.employeeid ? [currentUser.employeeid] : [],
          userId: userInfo.userid,
          country: country,
          clientId: ClientId,
        }
      );

      const result = {
        pendingCounts: {
          timesheet: response?.timesheetCount ?? 0,
          billing: response?.billingCount ?? 0,
          pfa: response?.pfaCount ?? 0,
          leave: response?.leaveApprovalCount ?? 0,
          appraisal: response?.appraisalCount ?? 0,
        },
        lastUpdated: {
          timesheet: response?.timesheetLastUpdated ?? null,
          billing: response?.billingLastUpdated ?? null,
          pfa: response?.pfaLastUpdated ?? null,
          leave: response?.leaveLastUpdated ?? null,
          appraisal: response?.appraisalLastUpdated ?? null,
        },
      };

      setData(result);
    } catch (err) {
      console.error("Notification count fetch failed:", err);
    } finally {
      setIsLoading(false);
    }
  }, [userInfo?.userid, country, ClientId]);

  useEffect(() => {
    fetchNotificationCounts();
  }, [fetchNotificationCounts]);

  return {
    isLoading,
    pendingCounts: data.pendingCounts,
    lastUpdated: data.lastUpdated,
  };
};

export default usePendingCounts;